<script setup lang="ts">
import NotificationsHub from "./NotificationsHub.vue";
</script>

<template>
  <NotificationsHub />
</template>
